import React from 'react';
import './Footer.css';

function Footer() {
  return (
    <footer className="site-footer">
      <div className="footer-inner two-column">
        <div className="footer-left">
          <div className="footer-copy">© {new Date().getFullYear()} Европа такси. Всички права запазени.</div>
          <div className="footer-links">
            <a href="/terms">Условия за ползване</a>
          </div>
        </div>

        <div className="footer-right">
          <h3>Контакти</h3>
          <div className="contact-item">Адрес: гр Русе, ул. Чипровци 31 /до стадион Дунав/</div>
          <div className="contact-item">Имейл: gumi_evropa@abv.bg</div>
          <div className="contact-item">Тел: 0888 730 685</div>
          <div className="contact-item">Тел: 0885 903 579</div>
        </div>
      </div>
    </footer>
  );
}   

export default Footer;
